export const COURSE_SERIES = Object.freeze({
    COMPLIANCE_CONNECTIONS: 1,
    SLA_UNIVERSITY: 2,
  });